module.exports = window.CLODOP;


//////////////////
// WEBPACK FOOTER
// external "window.CLODOP"
// module id = 1870
// module chunks = 1